import { HT } from "../siteConfig";
import { useState, useEffect, useRef } from "react";
import logo from "../assets/clinique-logo.png"; 

// ─── NAV DATA ───────────────────────────────────────────────────────────────

const branchItems = [
  { label: "Navi Mumbai (Kharghar)", href: "https://navimumbai.hairclinique.in/description.php" },
  { label: "Pune", href: "https://pune.hairclinique.in" },
  { label: "Bengaluru", href: "https://bangalore.hairclinique.in" },
  { label: "Shirdi", href: "https://shirdi.hairclinique.in" },
];

const htMumbaiItems = [
  // { label: "Hair Transplant in Kharghar", href: "/hair-transplant-in-mumbai.php" },
  // { label: "Hair Transplant in Ulwe", href: "/hair-transplant-in-mumbai.php" },
  // { label: "Hair Transplant in Navi Mumbai", href: "/hair-transplant-in-mumbai.php" },
  { label: "Hair Transplant in Mumbai", href: "/hair-transplant-in-mumbai.php" },
];

const htIndiaItems = [
  { label: HT.inLabel, href: HT.inPath },
  { label: HT.costLabel, href: HT.costPath },
  { label: HT.surgeryLabel, href: HT.surgeryPath },
];

const treatmentsMega = {
  hairLoss:[
  { label: "Male Hair Loss", href: "/male-hair-loss.php" },
  { label: "Female Hair Loss", href: "/female-hair-loss.php" },
  ],
  surgical: [
    { label: "About Hair Transplant", href: "/about-hair-transplants.php" },
    { label: "Male Hair Transplant", href: "/male-hair-transplants.php" },
    { label: "Female Hair Transplant", href: "/female-hair-transplants.php" },
    { label: "Beard Hair Transplant", href: "/beard-hair-transplants.php" },
    { label: "Eyebrow Hair Transplant", href: "/eyebrow-hair-transplants.php" },
    { label: "Body Hairs Transplant", href: "/body-hairs-transplants.php" },
    { label: "Hairline Reconstruction", href: "/hairline-reconstruction.php" },
    { label: "Eyelash Hair Transplant", href: "/eyelash-hair-transplants.php" },
  ],
  nonSurgical: [
    { label: "Platelet Rich Plasma (PRP)", href: "/platelet-rich-plasma.php" },
    { label: "Laser Light Therapy", href: "/laser-light-therapy.php" },
    { label: "Cyclic Vitamin Therapy", href: "/cyclic-vitamin-therapy.php" },
    { label: "Topical Therapy", href: "/topical-therapy.php" },
  ],
  techniques: [
    { label: "Follicular Unit Extraction (FUE)", href: "/follicular-unit-extraction.php" },
    { label: "Follicular Unit Transplant (FUT)", href: "/follicular-unit-transplant.php" },
  ],
};

// Category order + headings for the mobile treatments panel (reuses treatmentsMega, no duplicated data)
const treatmentGroups = [
  { title: "Hair Loss", items: treatmentsMega.hairLoss },
  { title: "Surgical", items: treatmentsMega.surgical },
  { title: "Non-Surgical", items: treatmentsMega.nonSurgical },
  { title: "Hair Transplant Techniques", items: treatmentsMega.techniques },
];

const navLinks = [
  { label: "Home", href: "/" },
  { label: "About", dropdown: [
    { label: "About Us", href: "/description.php" }, 
    { label: "Our Team", href: "/our-Surgeons.php" },
    {label: "Blogs", href:"https://www.hairclinique.in/blog/"},
    { label: "Testimonials", href: "/client-testimonials.php" },
    { label: "Faq", href: "/faq.php" },] },
  { label: "Results", href: "/results"},
  { label: "HT Mumbai", dropdown: htMumbaiItems }, 
  { label: HT.menu, dropdown: htIndiaItems },
  { label: "Our Treatments", mega: true },
  { label: "Hair Transplant Cost", href: HT.costPath },
];

// ─── SUB COMPONENTS ─────────────────────────────────────────────────────────

function ChevronIcon({ open }) {
  return (
    <svg
      className={`w-3 h-3 shrink-0 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
      fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  );
}

function DropdownMenu({ items, isOpen }) {
  return (
    <div
      className={`absolute top-full left-0 mt-0 w-60 z-50 transition-all duration-200 origin-top rounded-b-sm ${
        isOpen ? "opacity-100 scale-y-100 pointer-events-auto" : "opacity-0 scale-y-95 pointer-events-none"
      }`}
      style={{ background: "#110e04", border: "1px solid rgba(201,168,76,0.15)", borderTop: "none" }}
    >
      {items.map((item, i) => (
        <a
          key={i}
          href={item.href}
          className="block px-5 py-3 text-[14px] text-white/80 hover:text-white hover:bg-white/5 transition-colors duration-150 border-b border-white/5 last:border-0"
          style={{ fontFamily: "'Cinzel', serif" }}
        >
          {item.label}
        </a>
      ))}
    </div>
  );
}

function MegaMenu({ isOpen }) {
  return (
    <div
      className={`absolute top-full left-1/2 -translate-x-1/2 w-[1100px] max-w-[95vw] z-50 transition-all duration-200 origin-top rounded-b-sm ${
  isOpen ? "opacity-100 scale-y-100 pointer-events-auto" : "opacity-0 scale-y-95 pointer-events-none"
}`}
      style={{ background: "#110e04", border: "1px solid rgba(201,168,76,0.15)", borderTop: "none" }}
    >
      <div className="grid grid-cols-4 divide-x divide-white/[0.07] px-2 py-6">
  {/* Hair Loss */}
  <div className="px-5">
    <h4
      className="text-[13px] font-semibold text-white/40 uppercase tracking-[0.18em] mb-4"
      style={{ fontFamily: "'Cinzel', serif" }}
    >
      Hair Loss
    </h4>

    {treatmentsMega.hairLoss.map((item, i) => (
      <a
        key={i}
        href={item.href}
        className="block py-2 text-[14px] text-white/80 hover:text-white transition-colors duration-150"
        style={{ fontFamily: "'Cinzel', serif" }}
      >
        {item.label}
      </a>
    ))}
  </div>

  {/* Surgical */}
  <div className="px-5">
    <h4 className="text-[13px] font-semibold text-white/40 uppercase tracking-[0.18em] mb-4"
      style={{ fontFamily: "'Cinzel', serif" }}>
      Surgical
    </h4>
    {treatmentsMega.surgical.map((item, i) => (
      <a key={i} href={item.href}
        className="block py-2 text-[14px] text-white/80 hover:text-white transition-colors duration-150"
        style={{ fontFamily: "'Cinzel', serif" }}>
        {item.label}
      </a>
    ))}
  </div>

  {/* Non-Surgical */}
  <div className="px-5">
    <h4 className="text-[13px] font-semibold text-white/40 uppercase tracking-[0.18em] mb-4"
      style={{ fontFamily: "'Cinzel', serif" }}>
      Non-Surgical
    </h4>
    {treatmentsMega.nonSurgical.map((item, i) => (
      <a key={i} href={item.href}
        className="block py-2 text-[14px] text-white/80 hover:text-white transition-colors duration-150"
        style={{ fontFamily: "'Cinzel', serif" }}>
        {item.label}
      </a>
    ))}
  </div>

  {/* Hair Transplant Techniques */}
  <div className="px-5">
    <h4 className="text-[13px] font-semibold text-white/40 uppercase tracking-[0.18em] mb-4"
      style={{ fontFamily: "'Cinzel', serif" }}>
      Hair Transplant Techniques
    </h4>
    {treatmentsMega.techniques.map((item, i) => (
      <a key={i} href={item.href}
        className="block py-2 text-[14px] text-white/80 hover:text-white transition-colors duration-150"
        style={{ fontFamily: "'Cinzel', serif" }}>
        {item.label}
      </a>
    ))}
  </div>
</div>
    </div>
  );
}

// ─── MOBILE TREATMENTS PANEL (full-screen, slides in from the right) ────────

function MobileTreatmentsPanel({ isOpen, onBack, onNavigate }) {
  return (
    <div
      className="md:hidden fixed left-0 top-0 w-full z-[60] flex flex-col overflow-hidden"
      style={{
        height: "100dvh",
        background: "linear-gradient(180deg, #0a0800 0%, #0f0c02 100%)",
        transform: isOpen ? "translateX(0)" : "translateX(100%)",
        // keep it visible while sliding out, then hide it (removes it from tab order / screen readers)
        visibility: isOpen ? "visible" : "hidden",
        transition: isOpen
          ? "transform 350ms cubic-bezier(0.22, 1, 0.36, 1), visibility 0s linear 0s"
          : "transform 350ms cubic-bezier(0.22, 1, 0.36, 1), visibility 0s linear 350ms",
        willChange: "transform",
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Our Treatments"
      aria-hidden={!isOpen}
    >
      {/* Fixed header */}
      <div
        className="shrink-0 flex items-center gap-3 px-5 h-[76px] border-b border-white/[0.12]"
        style={{ paddingTop: "env(safe-area-inset-top)" }}
      >
        <button
          type="button"
          onClick={onBack}
          aria-label="Back to menu"
          className="-ml-2 p-2 text-[#c9a84c] hover:text-[#f5d27a] transition-colors"
        >
          <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
        </button>
        <h2
          className="text-[17px] font-semibold text-white tracking-[0.08em]"
          style={{ fontFamily: "'Cinzel', serif" }}
        >
          Our Treatments
        </h2>
      </div>

      {/* Scrollable content */}
      <div
        className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden overscroll-contain px-5 pt-5"
        style={{
          WebkitOverflowScrolling: "touch",
          paddingBottom: "calc(2rem + env(safe-area-inset-bottom))",
          scrollbarWidth: "thin",
          scrollbarColor: "rgba(201,168,76,0.4) transparent",
        }}
      >
        <div className="space-y-5">
          {treatmentGroups.map((group) => (
            <section
              key={group.title}
              className="rounded-xl px-4 py-4"
              style={{
                background: "rgba(255,255,255,0.03)",
                border: "1px solid rgba(201,168,76,0.18)",
              }}
            >
              <h3
                className="pb-3 mb-1 text-[12px] font-semibold uppercase tracking-[0.2em] text-[#c9a84c] border-b border-[#c9a84c]/20"
                style={{ fontFamily: "'Cinzel', serif" }}
              >
                {group.title}
              </h3>

              <ul>
                {group.items.map((item) => (
                  <li key={item.href} className="border-b border-white/[0.06] last:border-0">
                    <a
                      href={item.href}
                      onClick={onNavigate}
                      className="flex items-center gap-3 py-3.5 text-[14px] text-white/80 hover:text-white active:text-white transition-colors"
                      style={{ fontFamily: "'Cinzel', serif", letterSpacing: "0.03em" }}
                    >
                      <svg
                        className="w-3.5 h-3.5 shrink-0 text-[#c9a84c]"
                        fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M7 17L17 7M9 7h8v8" />
                      </svg>
                      <span className="min-w-0">{item.label}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}

// ─── MAIN NAVBAR ─────────────────────────────────────────────────────────────

export default function Navbar() {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileExpanded, setMobileExpanded] = useState(null);
  const [mobileTreatmentsOpen, setMobileTreatmentsOpen] = useState(false);
  const [mobileBranchesOpen, setMobileBranchesOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navRef = useRef(null);
  const mobileBranchesRef = useRef(null);
  const timeoutRef = useRef(null);

  // Closes the whole mobile navigation (menu + treatments panel)
  const closeMobileNav = () => {
    setMobileOpen(false);
    setMobileTreatmentsOpen(false);
    setMobileBranchesOpen(false);
  };

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const onClick = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setOpenDropdown(null);
        setMobileOpen(false);
        setMobileTreatmentsOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  // Close the mobile Our Branches dropdown when tapping/clicking outside it
  useEffect(() => {
    if (!mobileBranchesOpen) return;
    const onOutside = (e) => {
      if (mobileBranchesRef.current && !mobileBranchesRef.current.contains(e.target)) {
        setMobileBranchesOpen(false);
      }
    };
    document.addEventListener("mousedown", onOutside);
    document.addEventListener("touchstart", onOutside, { passive: true });
    return () => {
      document.removeEventListener("mousedown", onOutside);
      document.removeEventListener("touchstart", onOutside);
    };
  }, [mobileBranchesOpen]);

  // Lock background page scroll while the treatments panel is open
  useEffect(() => {
    if (!mobileTreatmentsOpen) return;
    const prevBodyOverflow = document.body.style.overflow;
    const prevHtmlOverflow = document.documentElement.style.overflow;
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prevBodyOverflow;
      document.documentElement.style.overflow = prevHtmlOverflow;
    };
  }, [mobileTreatmentsOpen]);

  // Escape = back one level; also reset the panel if the screen grows to desktop width
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setMobileTreatmentsOpen(false);
    };
    const onResize = () => {
      if (window.innerWidth >= 768) {
        setMobileTreatmentsOpen(false);
        setMobileBranchesOpen(false);
      }
    };
    window.addEventListener("keydown", onKey);
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  const enter = (i) => { clearTimeout(timeoutRef.current); setOpenDropdown(i); };
  const leave = () => { timeoutRef.current = setTimeout(() => setOpenDropdown(null), 120); };

  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />

      {/* Shiny gold button keyframes */}
      <style>{`
        @keyframes goldShine {
          0%   { background-position: -200% center; }
          100% { background-position: 200% center; }
        }
        .btn-gold-shine {
          background: linear-gradient(
            105deg,
            #7d5a0a 0%,
            #c9943a 20%,
            #f5d27a 38%,
            #ffe9a0 50%,
            #f5d27a 62%,
            #c9943a 80%,
            #7d5a0a 100%
          );
          background-size: 200% auto;
          animation: goldShine 3s linear infinite;
          color: #1a0f00;
          font-weight: 700;
        }
        .btn-gold-shine:hover {
          animation-duration: 1.2s;
          filter: brightness(1.08);
        }
        @media (prefers-reduced-motion: reduce) {
          .btn-gold-shine { animation: none; }
        }
      `}</style>

      <nav
        ref={navRef}
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "shadow-md shadow-black/70" : ""}`}
        style={{ background: "linear-gradient(180deg, #0a0800 0%, #0f0c02 100%)" }}
      >
        {/* ── TOP ROW ── */}
        <div className="border-b border-white/[0.07]">
          <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between h-19">

            {/* Logo — bigger, no text */}
            <a href="/" className="flex items-center shrink-0">
              {/*
                Replace below div with your actual logo image:
                <img src={logo} alt="HairClinique" className="h-16 w-auto" />
              */}
              <img src={logo} alt="HairClinique" className="h-16 w-auto" />
            </a>

            {/* Right — desktop */}
            <div className="hidden md:flex items-center gap-3">
              {/* Our Branches selector */}
              <div
                className="relative"
                onMouseEnter={() => enter("branches-top")}
                onMouseLeave={leave}
              >
                <button
                  className="flex items-center gap-2 px-4 py-2 text-white/80 hover:text-white transition-colors"
                  style={{ fontFamily: "'Cinzel', serif" }}
                >
                  <svg className="w-5 h-5 text-[#c9a84c]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <span
                    className="text-[14px] tracking-wide"
                    style={{ fontFamily: "'Cinzel', serif" }}
                  >
                    Our Branches
                  </span>
                  <ChevronIcon open={openDropdown === "branches-top"} />
                </button>
                <DropdownMenu items={branchItems} isOpen={openDropdown === "branches-top"} />
              </div>

              {/* Contact Us */}
              <a
                href="/khargharNaviMumbai.php"
                className="px-6 py-2.5 text-[14px] tracking-[0.08em] text-white border border-white/30 hover:border-white/60 rounded-full transition-all duration-200"
                style={{ fontFamily: "'Cinzel', serif" }}
              >
                Contact Us
              </a>

              {/* Get Appointment — shiny gold */}
              <a
                href="/khargharNaviMumbai.php"
                className="btn-gold-shine flex items-center gap-2 px-6 py-2.5 text-[14px] tracking-[0.08em] rounded-full"
                style={{ fontFamily: "'Cinzel', serif" }}
              >
                <svg className="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                Get Appointment
              </a>
            </div>

            {/* Mobile right side — Our Branches CTA + hamburger */}
            <div className="md:hidden flex items-center gap-2 shrink-0">
              {/* Our Branches (mobile) */}
              <div className="relative" ref={mobileBranchesRef}>
                <button
                  type="button"
                  onClick={() => {
                    setMobileBranchesOpen((v) => !v);
                    setMobileOpen(false);
                    setMobileTreatmentsOpen(false);
                  }}
                  aria-haspopup="true"
                  aria-expanded={mobileBranchesOpen}
                  className="flex items-center gap-1.5 px-3 py-2 text-[12px] tracking-[0.04em] text-white border border-[#c9a84c]/60 hover:border-[#c9a84c] rounded-full whitespace-nowrap transition-colors"
                  style={{ fontFamily: "'Cinzel', serif" }}
                >
                  <svg className="w-4 h-4 text-[#c9a84c]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  Our Branches
                  <span className="text-[#c9a84c]"><ChevronIcon open={mobileBranchesOpen} /></span>
                </button>

                <div
                  className={`absolute right-0 top-full mt-2 w-60 max-w-[calc(100vw-2.5rem)] z-50 rounded-sm overflow-hidden transition-all duration-200 origin-top-right ${
                    mobileBranchesOpen
                      ? "visible opacity-100 scale-100 pointer-events-auto"
                      : "invisible opacity-0 scale-95 pointer-events-none"
                  }`}
                  style={{ background: "#110e04", border: "1px solid rgba(201,168,76,0.25)" }}
                >
                  {branchItems.map((item, i) => (
                    <a
                      key={i}
                      href={item.href}
                      onClick={() => setMobileBranchesOpen(false)}
                      className="block px-5 py-3 text-[14px] text-white/80 hover:text-white active:bg-white/5 transition-colors duration-150 border-b border-white/5 last:border-0"
                      style={{ fontFamily: "'Cinzel', serif" }}
                    >
                      {item.label}
                    </a>
                  ))}
                </div>
              </div>

              {/* Mobile hamburger */}
              <button
                onClick={() => {
                  if (mobileOpen) setMobileTreatmentsOpen(false);
                  setMobileBranchesOpen(false);
                  setMobileOpen(!mobileOpen);
                }}
                className="flex flex-col gap-1.25 p-2"
                aria-label="Toggle menu"
              >
                <span className={`block w-6 h-0.5 bg-[#c9a84c] transition-all duration-300 ${mobileOpen ? "rotate-45 translate-y-1.75" : ""}`} />
                <span className={`block w-6 h-0.5 bg-[#c9a84c] transition-all duration-300 ${mobileOpen ? "opacity-0" : ""}`} />
                <span className={`block w-6 h-0.5 bg-[#c9a84c] transition-all duration-300 ${mobileOpen ? "-rotate-45 -translate-y-1.75" : ""}`} />
              </button>
            </div>
          </div>
        </div>

        {/* ── BOTTOM ROW — Desktop Nav Links ── */}
        <div className="hidden md:block">
          <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <div className="flex items-center gap-0 h-12.5">
              {navLinks.map((link, i) => (
                <div
                  key={i}
                  className="relative"
                  onMouseEnter={() => enter(i)}
                  onMouseLeave={leave}
                >
                  {link.dropdown || link.mega ? (
                    <button
                      className="flex items-center gap-1.5 px-5 py-2 text-[15px] text-white/80 hover:text-white transition-colors duration-150 whitespace-nowrap"
                      style={{ fontFamily: "'Cinzel', serif", letterSpacing: "0.06em" }}
                    >
                      {link.label}
                      <ChevronIcon open={openDropdown === i} />
                    </button>
                  ) : (
                    <a
                      href={link.href}
                      className="flex items-center px-5 py-2 text-[15px] text-white/80 hover:text-white transition-colors duration-150 whitespace-nowrap"
                      style={{ fontFamily: "'Cinzel', serif", letterSpacing: "0.06em" }}
                    >
                      {link.label}
                    </a>
                  )}

                  {link.dropdown && <DropdownMenu items={link.dropdown} isOpen={openDropdown === i} />}
                  {link.mega && <MegaMenu isOpen={openDropdown === i} />}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── MOBILE MENU ── */}
        <div
  className={`md:hidden overflow-x-hidden overflow-y-auto transition-all duration-300 border-t border-white/[0.07] ${
    mobileOpen
      ? "max-h-[calc(100dvh-76px)] opacity-100"
      : "max-h-0 opacity-0"
  }`}
  style={{
    background: "#0a0800",
    WebkitOverflowScrolling: "touch",
  }}
>
          <div className="px-5 py-3 space-y-0.5">
            
{navLinks.map((link, i) => {
              // Our Treatments → opens the full-screen slide-in panel instead of expanding inline
              if (link.mega) {
                return (
                  <div key={i}>
                    <button
                      type="button"
                      onClick={() => setMobileTreatmentsOpen(true)}
                      className="w-full flex items-center justify-between px-3 py-3.5 text-[15px] text-white/80 hover:text-white transition-colors"
                      style={{ fontFamily: "'Cinzel', serif", letterSpacing: "0.05em" }}
                      aria-haspopup="dialog"
                      aria-expanded={mobileTreatmentsOpen}
                    >
                      {link.label}
                      <svg
                        className="w-3.5 h-3.5 shrink-0"
                        fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                      </svg>
                    </button>
                  </div>
                );
              }

              const items = link.dropdown;

              return (
                <div key={i}>
                  {items ? (
                    <>
                      <button
                        onClick={() => setMobileExpanded(mobileExpanded === i ? null : i)}
                        className="w-full flex items-center justify-between px-3 py-3.5 text-[15px] text-white/80 hover:text-white transition-colors"
                        style={{ fontFamily: "'Cinzel', serif", letterSpacing: "0.05em" }}
                      >
                        {link.label}
                        <ChevronIcon open={mobileExpanded === i} />
                      </button>
                      <div
                        className={`transition-[max-height] duration-300 ${
  mobileExpanded === i
    ? "max-h-[2000px] overflow-visible"
    : "max-h-0 overflow-hidden"
}`}
                      >
                        <div className="pl-4 border-l border-[#c9a84c]/20 ml-3 mb-2">
                          {items.map((item, j) => (
                            <a
                              key={j}
                              href={item.href}
                              onClick={closeMobileNav}
                              className="block px-3 py-2.5 text-[13px] text-white/55 hover:text-white/90"
                              style={{ fontFamily: "'Cinzel', serif" }}
                            >
                              {item.label}
                            </a>
                          ))}
                        </div>
                      </div>
                    </>
                  ) : (
                    <a
                      href={link.href}
                      className="block px-3 py-3.5 text-[15px] text-white/80 hover:text-white transition-colors"
                      style={{ fontFamily: "'Cinzel', serif", letterSpacing: "0.05em" }}
                      onClick={closeMobileNav}
                    >
                      {link.label}
                    </a>
                  )}
                </div>
              );
            })}

            {/* Mobile CTAs */}
            <div className="pt-4 pb-3 flex flex-col gap-3 border-t border-white/[0.07] mt-2">
              <a
                href="#contact"
                className="text-center py-3 text-[14px] tracking-[0.08em] text-white border border-white/30 rounded-full"
                style={{ fontFamily: "'Cinzel', serif" }}
              >
                Contact Us
              </a>
              <a
                href="#appointment"
                className="btn-gold-shine flex items-center justify-center gap-2 py-3 text-[14px] tracking-[0.08em] rounded-full"
                style={{ fontFamily: "'Cinzel', serif" }}
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                Get Appointment
              </a>
            </div>
          </div>
        </div>

        {/* ── MOBILE TREATMENTS PANEL (slides in from the right, covers the hamburger menu) ── */}
        <MobileTreatmentsPanel
          isOpen={mobileOpen && mobileTreatmentsOpen}
          onBack={() => setMobileTreatmentsOpen(false)}
          onNavigate={closeMobileNav}
        />
      </nav>
    </>
  );
}